'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import tinymce from 'tinymce';
import FontSizeSelect from 'rich-text-lib/components/formatting/FontSizeSelect';
import { CHANGE_FONT_SIZE } from '../../constants/usageTracking';
import { trackInteraction } from '../../utils/usageTracking';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TinyMceFontSize extends Component {
  constructor(props) {
    super(props);
    this.handleChangeFont = (value, method) => {
      const {
        editor
      } = this.props;
      editor.execCommand('hsfontsize', false, {
        value
      });
      trackInteraction(editor, 'tinymceFormatting', CHANGE_FONT_SIZE, {
        method,
        value
      });
    };
    this.fontSizes = props.fontSizes;
  }
  render() {
    const {
      placeholder,
      fontSize
    } = this.props;
    return /*#__PURE__*/_jsx(FontSizeSelect, {
      dropdownClassName: "mce-hubspot-control",
      use: "on-dark",
      onChange: this.handleChangeFont,
      placeholder: placeholder,
      fontSizes: this.fontSizes,
      value: fontSize
    });
  }
}
TinyMceFontSize.propTypes = {
  editor: PropTypes.instanceOf(tinymce.Editor),
  fontSizes: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  fontSize: PropTypes.string
};